import { useEffect, useState } from "react";
import { api } from "./api";
import { CITY_PRICES } from "./site";

// Precios vigentes por par de ciudades ("A|B" -> [semicama, cama]). Arranca con los del tarifario y se actualiza con el sistema.
let cache = null;
let pending = null;

export const useLivePrices = () => {
  const [prices, setPrices] = useState(cache || CITY_PRICES);
  useEffect(() => {
    let alive = true;
    if (!cache) {
      pending = pending || api.get("/public/prices").then((r) => { cache = { ...CITY_PRICES, ...(r.data && typeof r.data === "object" ? r.data : {}) }; return cache; }).catch(() => CITY_PRICES);
      pending.then((p) => { if (alive) setPrices(p); });
    }
    return () => { alive = false; };
  }, []);
  return prices;
};

export const priceOf = (prices, a, b, cat = 0) => prices?.[`${a}|${b}`]?.[cat] ?? null;
